'use client'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowLeft } from '@redteclab/icons'

import { Button } from 'base-ui'
import { useActivateContentsquareExperiment } from 'contentsquare'

import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetContactUs } from '../../url-handling'

const EXPERIMENT_NAME = 'wscnl-9512'

export const OtherTopicsContactHeader: FC = () => {
  useActivateContentsquareExperiment(EXPERIMENT_NAME)
  const config = useGlobalConfigContext()
  const intl = useIntl()

  const otherTopicsHelpTitle = intl.formatMessage({
    id: 'help.centre.others.options.title',
  })

  return (
    <div className="container flex flex-col">
      <div className="flex w-full pb-4">
        <Button<'a'>
          className="text-m font-medium text-dark-primary-max"
          href={urlResolverGetContactUs(config, {
            queryParams: { target: 'other-topics' },
          })}
          slots={{ root: 'a' }}
          startIcon={<IconArrowLeft />}
          variant="text"
        >
          <FormattedMessage id="help.centre.back.button" />
        </Button>
      </div>
      <div className="flex w-full flex-col tablet:justify-center">
        <h1 className="mb-3 text-2xl font-medium text-dark-primary-max tablet:text-center">
          {otherTopicsHelpTitle}
        </h1>
        <div className="flex w-full tablet:justify-center">
          <p className="w-full text-l font-normal text-dark-primary-strong tablet:max-w-xl tablet:text-center">
            <FormattedMessage id="help.centre.others.options.subtitle" />
          </p>
        </div>
      </div>
    </div>
  )
}
